import { InjectionToken } from '@angular/core';

export const COURSE_ROUTE = new InjectionToken<string[]>('COURSE_ROUTE');
export const CAPACITOR_LOGOUT_RETURN_TO = new InjectionToken<string>(
	'LOGOUT_RETURN_TO'
);
export const IS_CAPACITOR_APP = new InjectionToken<boolean>('IS_CAPACITOR_APP');
export const AUTH0_CLIENT_ID = new InjectionToken<string>('AUTH0_CLIENT_ID');
